export interface ParsedOutput {
  backup_app_service_principal_id?: string;
  restore_app_application_id?: string;
  restore_app_service_principal_id?: string;
  managed_identity_resource_id?: string;
  agent_app_application_id?: string;
  agent_app_service_principal_id?: string;
  agent_managed_identity_resource_id?: string;
}

type OutputFormat = 'terraform' | 'bash';

function unwrapValue(val: unknown): string | undefined {
  if (typeof val === 'string') {
    return val;
  }
  if (val && typeof val === 'object' && 'value' in val) {
    const inner = val.value;
    if (typeof inner === 'string') {
      return inner;
    }
    if (inner && typeof inner === 'object') {
      return unwrapValue(inner);
    }
  }
  return undefined;
}

export function parseOutput(
  input: string,
  format: OutputFormat
): ParsedOutput | null {
  try {
    const parsed = JSON.parse(input.trim());

    if (format === 'bash') {
      return parsed as ParsedOutput;
    }

    return Object.fromEntries(
      Object.entries(parsed)
        .map(([key, val]) => [key, unwrapValue(val)])
        .filter(([, val]) => val !== undefined)
    ) as ParsedOutput;
  } catch {
    return null;
  }
}
